export default __webpack_public_path__ + "static/media/email.5658a855.svg";